// extracted by mini-css-extract-plugin
export default {"legendMobile__container":"LegendMobile_legendMobile__container__LSsPZ","legend":"LegendMobile_legend__7fCME","legend__item__container":"LegendMobile_legend__item__container__ZKwnr"};